import { render, staticRenderFns } from "./StorageWarehouse.vue?vue&type=template&id=167442ae&scoped=true&"
import script from "./StorageWarehouse.vue?vue&type=script&lang=js&"
export * from "./StorageWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./StorageWarehouse.vue?vue&type=style&index=0&id=167442ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167442ae",
  null
  
)

export default component.exports